const fetchState = {
  requests: {},
  responses: {},
  errors: {},
}

export default fetchState
